import Header from "../components/Header";
import Hero from "../components/Hero";
import Features from "../components/Features";
import About from "../components/About";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";

const LandingPage = () => (
  <>
    <Header />
    <Hero />
    <Features />
    <About />
    <ContactForm />
    <Footer />
  </>
);

export default LandingPage;
